import React, { useState } from 'react';
import { ProviderId } from './contracts';
import venmo from './assets/venmo.png';
import cashApp from './assets/cash-app.png';
import zelle from './assets/zelle.png';

const logos = { venmo, cash_app: cashApp, zelle };
export function PaymentProviderBrand({ provider, label }: { provider?: ProviderId; label: string }) {
  const [failed, setFailed] = useState<string | null>(null);
  const branded = provider === 'venmo' || provider === 'cash_app' || provider === 'zelle' ? provider : null;
  return <span className="payment-v2-brand">{branded && failed !== branded
    ? <img src={logos[branded]} alt={label} onError={() => setFailed(branded)} style={{ width: `var(--vs-payment-${branded}-width)`, height: `var(--vs-payment-${branded}-height)` }} />
    : <span>{label}</span>}</span>;
}
